import { getKycState } from "@/features/kyc/utils/kyc-state";

export type AfterPaymentRoute =
  | "/dashboard"
  | "/kyc-verification"
  | "/kyc-verification-pending"
  | "/kyc-verification-rejected"
  | "/plan/membership"
  | null;

type ResolveRouteAfterPaymentSuccessParams = {
  membershipStatus?: string | null;
  kycStatus?: string | null;
  kycAttemptStatus?: string | null;
};

export const resolveRouteAfterPaymentSuccess = ({
  membershipStatus,
  kycStatus,
  kycAttemptStatus,
}: ResolveRouteAfterPaymentSuccessParams): AfterPaymentRoute => {
  const normalizedMembershipStatus = membershipStatus?.toUpperCase() ?? "";

  if (normalizedMembershipStatus === "PENDING") {
    return null;
  }

  if (normalizedMembershipStatus !== "ACTIVE") {
    return "/plan/membership";
  }

  const kycState = getKycState(kycStatus, kycAttemptStatus);

  if (kycState === "verified") {
    return "/dashboard";
  }

  if (kycState === "rejected") {
    return "/kyc-verification-rejected";
  }

  if (kycState === "pending") {
    return "/kyc-verification-pending";
  }

  return "/kyc-verification";
};
